import GoatLeg from "../assets/images/goat_leg.png";
import GoatShoulder from "../assets/images/goat_shoulder.png";
import FreeRunChicken from "../assets/images/free_run_chicken.png";
import MuttonShoulder from "../assets/images/mutton_shoulder.png";
import MuttonLeg from "../assets/images/mutton_leg.png";
import Oxtail from "../assets/images/oxtail.png";
import ChickenLeg from "../assets/images/chicken_leg.png";
import UnburnRooster from "../assets/images/rooster.png";
import Duck from "../assets/images/duck.png";
import Drake from "../assets/images/drake1.png";
import OrganicChicken from "../assets/images/organic_chicken.png";
import HeavyChicken from "../assets/images/heavy_chicken.png";
import BurnDuck from "../assets/images/burned_duck.png";
import Rooster from "../assets/images/burned_roaster.png";
export const products = [
  {
    id: "1",
    img: FreeRunChicken,
    title: "Free Run Chicken",
    text:
      "A top favorite amongst our clients is the free run chicken. Supreme in taste and flavor, our birds come from the farm of local farmers. Free from pesticides, artificial growth hormones or steroids, we offera variety of cuts and also offer it singed with a lip-smacking flavor. Antibiotic free and organic chickens are also available.",
  },
  {
    id: "2",
    img: MuttonShoulder,
    title: "Mutton Shoulder",
    text:
      "We offer both fresh and frozen mutton ina variety of cuts. Known for its tender texture, which also gives a great flavor, our animals are raised in complete free range and healthy environments, without any kind of artificial hormonesor steroids, they freely graze in open fields. Away from commercial farming, we follow benevolent ways to raise our animals which may justify the utmost quality of meat that our farms are known to produce.",
  },
  {
    id: "3",
    img: MuttonLeg,
    title: "Mutton Leg",
    text: "Coming soon",
  },
  {
    id: "4",
    img: Oxtail,
    title: "Oxtail",
    text:
      "Full of flavor, oxtail meat comes from the tail of a cow. As oxtail is often slow-cooked due to its nutritious bone and rich texture, oxtail meat is perfect for braising. Popularly used for stew or stocks, we offer both frozen and fresh options. Frozen oxtail comes from Australia and fresh comes from our partner farms in Ontario. The animals are raised in a natural and healthy environment. We also offer Beef, which again comes from the animals raised in open pastures of Ontario. Kept in free-range, healthy environments, these animals are fed on grass and high quality grains. All cuts are available.",
  },
  {
    id: "5",
    img: ChickenLeg,
    title: "Chicken Leg quarters",
    text:
      "Chicken legs and all cuts of chicken should go into the free run chicken category and the chicken category",
  },
  {
    id: "6",
    img: Duck,
    title: "Duck hen",
    text:
      "These are the laying hens.Offering the same qualities as our rooster or other chickens, heavy hen is a softer meat then rooster but tougher than regular chicken.",
  },
  {
    id: "7",
    img: Rooster,
    title: "Burned Rooster",
    text:
      "Heavy on protein, roosters make for great delicacies when used in soups, stews, curries or even dried down (bunjalor bungal). Our roosters are grown in farms of Ontario in a complete free-run environment and also are used for breeding with laying hens. While growing in a natural cage-free environment, none of our birds are contacted with any kind of artificial growth hormones or steroids. Fed on high quality grains, the tough meat of the roosters may take a while to be cooked, but the taste pays off for the trouble. To facilitate our consumers, all birds are offered burnt or regular, and with or without the parts of head or feet. The ‘Burn’ options are the same delicious birds of Sheik Halal Farms, just singed for a succulent flavor.",
  },
  {
    id: "8",
    img: GoatLeg,
    title: "Goat Leg",
    text: "Coming Soon",
  },
  {
    id: "9",
    img: Drake,
    title: "Drake",
    text:
      "With its higher quality meat in comparison to a Peking Duck, the Muscovy Duck of our farms have always garnered special admiration of our consumers. These birds grow in a complete free-range natural environment and are also free from any kind of antibiotics, pesticides or artificial growth hormones.Average 7 to 8 lbs and fed with high quality grains, they are reared at least for three months before the slaughter to ensure the tenderness of the meat, which adds to its popularity. The Breeder Drake is also available; which is a tough meat to be cooked, but is also preferred by a class of consumers.",
  },
  {
    id: "10",
    img: OrganicChicken,
    title: "Organic Chicken",
    text:
      "All free Run. Another of our clientele’s favorite, the chicken of our farms represents everything which has made this bird rule the roost of culinary world for ages. Supreme in taste and flavor, our birds come from the fields of Ontario and Quebec. Fed with nutritious high quality grain, they are raised in natural environment and reared for six to ten weeks. Free from pesticides or artificial growth hormones, we offer variety of cuts and also offer it singed with a lip-smacking smoky flavor.",
  },
  {
    id: "11",
    img: UnburnRooster,
    title: "Unburned Rooster",
    text:
      "Heavy on protein, roosters make for great delicacies when used in soups, stews, curries or even dried down (bunjalor bungal). Our roosters are grown in farms of Ontario in a complete free-run environment and also are used for breeding with laying hens. While growing in a natural cage-free environment, none of our birds are contacted with any kind of artificial growth hormones or steroids. Fed on high quality grains, the tough meat of the roosters may take a while to be cooked, but the taste pays off for the trouble. To facilitate our consumers, all birds are offered burnt or regular, and with or without the parts of head or feet. The ‘Burn’ options are the same delicious birds of Sheik Halal Farms, just singed for a succulent flavor.",
  },
  {
    id: "12",
    img: BurnDuck,
    title: "Burn Duck",
    text:
      "The Muscovy duck is native to Europe with better quality meat and less fat than other kinds of duck. All our ducks are free run, grain-fed, and given antibiotics, steroids or hormones",
  },
  {
    id: "13",
    img: GoatShoulder,
    title: "Goat Shoulder",
    text:
      "We offer both fresh and frozen goat in a variety of cuts. Known for its tender texture and great flavor, it is slowly growing in popularity.Our animals are raised in complete free range and healthy environments,without any kind of artificial hormones or steroids, they freely graze in open fields. We follow benevolent ways to raise our animals which justify the utmost quality of meat that our farms are known to produce.All cuts are available.",
  },
  {
    id: "14",
    img: HeavyChicken,
    title: "Heavy Chicken",
    text:
      "These are the laying hens, which are excellent for soups, curries, and stews. Offering the same qualities as our rooster or other chickens, heavy hen is a softer meat then rooster but tougher than regular chicken.",
  },
];
